import UserProfile from "./Components/UserProfile";

export default UserProfile;
